import { useLocation, useNavigate } from "react-router-dom";
import en from "./locales/en.json";
import it from "./locales/it.json";

export function getLang(search) {
  return new URLSearchParams(search).get("lang") === "it" ? "it" : "en";
}

export default function usePulseLocale() {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = getLang(location.search);

  const t = (key, vars) => {
    let s = (lang === "it" ? it[key] : en[key]) ?? en[key] ?? key;
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.split(`{${k}}`).join(v); });
    return s;
  };

  // Preserve the active locale on every internal Pulse link
  const withLang = (path) => {
    if (lang !== "it") return path;
    return path.includes("?") ? `${path}&lang=it` : `${path}?lang=it`;
  };

  const setLang = (next) => {
    const sp = new URLSearchParams(location.search);
    if (next === "it") sp.set("lang", "it"); else sp.delete("lang");
    const qs = sp.toString();
    navigate({ pathname: location.pathname, search: qs ? `?${qs}` : "" }, { replace: true });
  };

  return { lang, t, withLang, setLang };
}
